import PropTypes from 'prop-types';
import React, { Component } from 'react';
import GeckoDate from 'services/gecko-date';
import moment from 'moment';

class LocalTime extends Component {
  render() {
    const style = Object.assign({}, this.props.style);
    const timeString = new GeckoDate(moment().utcOffset(this.props.offset))
      .SHORT_TIME;
    return (
      <p style={style} className="system-details">
        {timeString}
      </p>
    );
  }
}

LocalTime.defaultProps = {
  offset: 0,
  style: {},
};

LocalTime.propTypes = {
  offset: PropTypes.number,
  style: PropTypes.object,
};

export default LocalTime;
